module.exports = "/templates/logincontrol.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/logincontrol.html
// module id = 453
// module chunks = 0